import { render, staticRenderFns } from "./SundryCreditorListView.vue?vue&type=template&id=e672b0b0"
import script from "./SundryCreditorListView.vue?vue&type=script&lang=js"
export * from "./SundryCreditorListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e672b0b0')) {
      api.createRecord('e672b0b0', component.options)
    } else {
      api.reload('e672b0b0', component.options)
    }
    module.hot.accept("./SundryCreditorListView.vue?vue&type=template&id=e672b0b0", function () {
      api.rerender('e672b0b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sundrycreditor/SundryCreditorListView.vue"
export default component.exports